export const APP = {
  VERSION_COMMIT_SHA: process.env.ENV.VERSION_COMMIT_SHA || '',
  VERSION_COMMIT_DATE: process.env.ENV.VERSION_COMMIT_DATE
    ? process.env.ENV.VERSION_COMMIT_DATE
    : '',
  VERSION_BRANCH: process.env.ENV.VERSION_BRANCH || '',
  BUILD_DATE: process.env.ENV.BUILD_DATE || '',
  NAME: process.env.ENV.APP_NAME,

  DAYJS_LOCALE: 'zh-tw',

  IDENTITY: '',

  ROUTES: {
    ENTRY: '/',
  },
} as const;

export type AppRoutes = (typeof APP.ROUTES)[keyof typeof APP.ROUTES];
